/*  ========================================================================
    # Scripts - Menu
    ========================================================================  */

/**
 * Script for the desktop menu
 */
const Menu = {
  cfg: {
    mobileMenuButton: document.querySelector('.c-header__mobile-menu-button'),
    mobileMenu: document.querySelector('.c-menu-mobile'),
    body: document.querySelector('body'),
    html: document.querySelector('html'),
    header: document.querySelector('.c-header'),
    closeButton: document.querySelector('.c-menu-mobile__close-button')
  },

  initMobileMenu() {
    this.cfg.mobileMenuButton.addEventListener('click', () => {
      const isMenuOpen = this.cfg.mobileMenu.classList.contains('c-menu-mobile--active');

      if (!isMenuOpen) {
        this.cfg.mobileMenu.classList.add('c-menu-mobile--active');
        this.cfg.html.classList.add('menu-open');
        this.cfg.mobileMenuButton.setAttribute('aria-expanded', 'true');

        // Find and scroll to header
        if (this.cfg.header) {
          this.cfg.header.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Closing menu - restore scroll position and allow scrolling
        this.cfg.mobileMenu.classList.remove('c-menu-mobile--active');
        this.cfg.body.classList.remove('menu-open');
        this.cfg.html.classList.remove('menu-open');
        this.cfg.mobileMenuButton.setAttribute('aria-expanded', 'false');
      }
    });

    this.cfg.closeButton.addEventListener('click', () => {
      this.cfg.mobileMenu.classList.remove('c-menu-mobile--active');
      this.cfg.body.classList.remove('menu-open');
      this.cfg.html.classList.remove('menu-open');
      this.cfg.mobileMenuButton.setAttribute('aria-expanded', 'false');
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1024 && this.cfg.mobileMenu.classList.contains('c-menu-mobile--active')) {
        this.cfg.mobileMenu.classList.remove('c-menu-mobile--active');
        this.cfg.body.classList.remove('menu-open');
        this.cfg.html.classList.remove('menu-open');
        this.cfg.mobileMenuButton.setAttribute('aria-expanded', 'false');
        this.cfg.body.style.top = '';
        if (this.cfg.header) {
          this.cfg.header.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    this.initMobileMenu();
  }
};

export default Menu;
